<template>
  <div :class="[`view-150`, className || ``]">
    <div class="view-151">
      <div class="text-193 fontawesome5free-solid-normal-black-20px"></div>
      <div class="text-194 poppins-semi-bold-black-20px">Домашние задания</div>
      <drawing :className="drawingProps.className" />
    </div>
  </div>
</template>

<script>
import Drawing from "./Drawing";
export default {
  name: "View672",
  components: {
    Drawing,
  },
  props: ["className", "drawingProps"],
};
</script>

<style>
.view-150 {
  align-items: center;
  display: flex;
  width: 265px;
}

.view-151 {
  height: 30px;
  position: relative;
  width: 269px;
}

.text-193 {
  left: 255px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: calc(50% - 10px);
  white-space: nowrap;
}

.text-194 {
  left: 38px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 0;
}

.view-150.view-156 {
  margin-left: 2px;
  margin-top: 20px;
}
</style>
